import Store from "../Stores/Store";

export function canPay() {
  if (!Store.payment.accounts.id_unified_account) {
    if (Store.payment.accounts.accounts.length === 1) {
      if (
        Store.payment.accounts.accounts[0].id_org === "1" ||
        Store.payment.accounts.accounts[0].id_org === 1
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return true;
  }
}